import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { routes } from './project.routes';
import { ProjectDetailComponent } from './project-detail.component';
import { ProjectService } from './project.service';
import { ProductionOfficeComponent } from './production-office.component';
import { ProductionContactComponent } from './production-contact.component';
import { ProjectContactComponent } from './project-contact.component';
import { AppService } from '../app.service';

import { AssetManagerModule } from "../shared/asset-manager.module";
import { TooltipCleanerDirective } from '../shared/tooltip-cleaner.directive';
import { SharedModule} from '../shared/shared.module';
import { ProjectListComponent } from './project-list/project-list.component';
import { UserDepartmentService } from '../user-department/user-department.service';

@NgModule({
  declarations: [
    /**
     * Components / Directives/ Pipes
     */
    ProjectDetailComponent,
    ProductionOfficeComponent,
    ProductionContactComponent,
    ProjectContactComponent,
    ProjectListComponent,
    TooltipCleanerDirective
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    AssetManagerModule,
    SharedModule
  ],
   providers: [
    ProjectService,
    UserDepartmentService
  ]
})
export class ProjectModule {
  public static routes = routes;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/project/project.module.ts